import React from 'react';
import { FormFieldset } from '@tesla/design-system-react';
import { useIntl } from 'react-intl';
import { arrayOf, shape, string } from 'prop-types';
import { FormField } from 'informed';
import formStyle from '../../JobApplicationForm/style.module.scss';
import { useTCLFormApi } from '../../../hooks';
import messages from './messages';

const JobDetailSection = ({ fields }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const { availability = [], experience = [], other = [] } = fields;
  const formHelper = useTCLFormApi();

  return (
    <FormFieldset className={formStyle.FormSection}>
      {availability.length > 0 && (
        <span className="tds-legend tds-text--h5">
          {formatMessage(messages.AvailabilityHeading)}
        </span>
      )}
      {availability.map((field) => (
        <div className={`${formStyle.FormFieldHalfWidth}`}>
          <FormField {...formHelper.field(field)} />
        </div>
      ))}

      {experience.length > 0 && (
        <span className="tds-legend tds-text--h5">{formatMessage(messages.ExperienceHeading)}</span>
      )}
      {experience.map((field) => (
        <div className={`${formStyle.FormFieldHalfWidth}`}>
          <FormField {...formHelper.field(field)} />
        </div>
      ))}

      {other.map((field) => (
        <div className={`${formStyle.FormFieldHalfWidth}`}>
          <FormField {...formHelper.field(field)} />
        </div>
      ))}
    </FormFieldset>
  );
};

JobDetailSection.propTypes = {
  fields: shape({
    availability: arrayOf(string),
    experience: arrayOf(string),
    other: arrayOf(string),
  }).isRequired,
};

export default JobDetailSection;
